import { render, staticRenderFns } from "./ChartDescriptionItem.vue?vue&type=template&id=cb7af314&scoped=true&"
import script from "./ChartDescriptionItem.vue?vue&type=script&lang=js&"
export * from "./ChartDescriptionItem.vue?vue&type=script&lang=js&"
import style0 from "./ChartDescriptionItem.vue?vue&type=style&index=0&id=cb7af314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7af314",
  null
  
)

export default component.exports